import AllRoutes from "./Components/AllRoutes";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Navlist from './Components/Navlist'

function App() {
  return (
    <div>
      <Navbar/>
      <Navlist/>
      <AllRoutes/>
      <Footer/>
    </div>
  );
}

export default App;
